export const DeliveryListCompanyPage = () => {
  return <>DeliveryListCompanyPage</>;
};
